import React from 'react';

function DeletePurchaseRegister({ selectedRow }) {
  const id = selectedRow?.PurchaseRegisterId;
  return (
    <div>
      <p>Are you sure you want to delete this purchase register?</p>
      <ul>
        <li>ID: {id}</li>
        <li>Dealer: {selectedRow?.DealerName}</li>
        <li>Date: {selectedRow?.PurchaseDate}</li>
      </ul>
      <p>This will perform a soft delete.</p>
    </div>
  );
}

export default DeletePurchaseRegister;
